import { useEffect, useState } from 'react';

/**
 * useReducedMotion — live boolean for the user's motion preference.
 * Returns true when `(prefers-reduced-motion: reduce)` matches, and updates
 * if the OS-level setting changes mid-session. SSR-safe (defaults to false
 * when window/matchMedia is unavailable).
 *
 * Usage:
 *   const reduced = useReducedMotion();
 *   if (!reduced) { ...start the auto-rotate... }
 */
const QUERY = '(prefers-reduced-motion: reduce)';

export default function useReducedMotion() {
  const [reduced, setReduced] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(QUERY).matches
      : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setReduced(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return reduced;
}
